import { render, staticRenderFns } from "./MatchNoneCDCLikelyAndGSRPReferral.vue?vue&type=template&id=60ffdd12&"
import script from "./MatchNoneCDCLikelyAndGSRPReferral.vue?vue&type=script&lang=ts&"
export * from "./MatchNoneCDCLikelyAndGSRPReferral.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports